import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'

import NotFound from '@/components/NotFound.vue'

import Match from '@/views/Match.vue'
import Event from '@/views/Event.vue'
import Events from "@/views/Events";
import MatchList from "@/components/Match/MatchList";
import HomeWidget from "@/views/HomeWidget";

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  }, {
    path: '/',
    name: 'home',
    component: Events,
    meta: {
      auth: false,
    },
  },{
     path: '/match/:id',
     name: 'match',
     component: Match,
     meta: {
      auth: false,
     },
  },{
        path: '/event/:id',
        name: 'event',
        component: Event,
        meta: {
            auth: false,
        },
    },
    {
        path: '/events',
        name: 'events',
        component: Events,
        meta: {
            auth: false,
        },
    },
    {
        path: '/widget/home',
        name: 'widget-home',
        component: HomeWidget,
        meta: {
            auth: false
        }
    },

];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
